// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] + "-" + {"125":"8e06daff37f1797977df","293":"f349bc004d975a7728a4"}[chunkId] + ".js";
};